module.exports = __webpack_public_path__ + "static/media/waistMale.dce6e742.png";